export default __webpack_public_path__ + "static/logo-f5484058ed6ce53825e15fbbdf3be07a.png";